'use client';
import { ReactNode, useState } from 'react';

import {
  Icons,
  FormButton,
  FormButtonProps,
  LinkButton,
} from '@monoimin/atoms';
import { Modal } from '@monoimin/molecules/Modal';

interface ModalButtonProps extends FormButtonProps {
  modalCard: ReactNode;
  linkButtonUrl: string;
}

export const ModalButton = ({
  modalCard,
  linkButtonUrl,
  ...props
}: ModalButtonProps) => {
  const [open, setOpen] = useState(false);
  if (linkButtonUrl) {
    return <LinkButton href={linkButtonUrl} {...props} />;
  }
  return (
    <>
      <FormButton {...props} data-testid="modal-trigger" onClick={() => setOpen(true)} />
      <Modal
        isOpen={open}
        setIsOpen={setOpen}
        panelContainerClassName='flex justify-center items-center'
        panelClassName='flex justify-center items-start relative'
      >
        {modalCard}
        <button
          aria-label='Close modal button'
          className='absolute top-2 right-8 md:top-0 md:right-0 md:relative button md:bg-white z-20 rounded-full w-10 h-10 flex justify-center items-center'
          onClick={() => setOpen(false)}
        >
          <Icons icon='close' sizeClassName='h-8 w-8' />
        </button>
      </Modal>
    </>
  );
};
